import { getApprovingCount,getAgencyApprove } from "@/api/saleApi.js";
import { getPendingCount } from "@/api/internalApi.js";
import { getMarketplacePendingCount } from "@/api/marketplaceApi.js";
import { getCompaignOneData } from '@/api/campaignApi.js';
import { getRequestProject } from '@/api/projectApi.js';
import { getProjectShareRequest} from'@/api/approveApi.js';

export default{
  WAITING_TOTAL(state){
    getApprovingCount().then(res=>{ //等待审批数量,小红点
      if (res.data.success) {
        state.commit('WAITING_TOTAL',res.data.data)
      }
    })
  },
  CHANNEL_WAITING_TOTAL(state){
    getAgencyApprove().then(res=>{ //等待审批数量,小红点
      if (res.data.success) {
        state.commit('CHANNEL_WAITING_TOTAL',res.data.total)
      }
    })
  },
  INTERNAL_PENDING_COUNT(state){
    getPendingCount().then(res=>{
      if (res.data.success) {
        state.commit('INTERNAL_PENDING_COUNT',res.data.data)
      }
    })
  },
  MARKETPLACE_PENDING_COUNT(state){
    getMarketplacePendingCount().then(res=>{
      if (res.data.success) {
        state.commit('MARKETPLACE_PENDING_COUNT',res.data.data)
      }
    })
  },
  CAMPAIGN_DATA(state, params){
    getCompaignOneData(params).then(res=>{
      if (res.data.success) {
        state.commit('CAMPAIGN_DATA',res.data.data)
      }
    })
  },
  SINGLE_LIST_DATA(state, params){
    getRequestProject().then(res=>{
      if(res.data.success){
        const data = res.data.data.filter(ele=>ele.status=='1');
        state.commit('SINGLE_LIST_DATA', data)
      }
    })
  },
  SHARED_LIST_DATA(state, params){
    getProjectShareRequest().then(res=>{
      if(res.data.success){
        const data = res.data.data.filter(ele=>ele.status=='1');
        state.commit('SHARED_LIST_DATA', data)
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js